export default "__VITE_ASSET__CkMYN21q__"